import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import {
  Typography,
  DialogTitle,
  FormHelperText,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Grid,
  TextField,
  Button,
  Paper,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import Search from "@material-ui/icons/Search";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import { useForm } from "react-hook-form";

const useStyles = makeStyles(() => ({
  root: {},
}));

const HeaderSelectsGrafica = (props) => {
  const {
    className,
    setCargando,
    title,
    subtitle,
    tamaño,
    clickSolicitudes,
    bandera,
    setValue,
    ctl,
    setCtl,
    watch,
    getSol,
    errors,
    ...rest
  } = props;
  const [data, setData] = useState([]);
  const { register, handleSubmit } = useForm();
  const [inputValue, setInputValue] = React.useState("");
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const fechaActual = year + "-" + month + "-" + day;
  const [datosF, setDato] = React.useState({
    estatus: "0",
    solicitud: "0",
  });
  var fechamin = fechaActual;
  var fechamax = "2090-12-31";
  const classes = useStyles();
  const BuscarSol = () => {
    clickSolicitudes();
  };
 
  const options = [
    {
      id: 100,
      nestatus: "TODO",
    },
    {
      id: 9,
      nestatus: "ACTIVO",
    },
    {
      id: 11,
      nestatus: "SIN ASIGNAR",
    },
    {
      id: 12,
      nestatus: "EN DESARROLLO",
    },
    {
      id: 13,
      nestatus: "CERRADA",
    },
  ];
  const [disabled, setDisabled] = useState(false);

  const handleChangeEstatus = (event, value) => {
    if (value) {
      setValue("estatus", value);
      setDato({ ...datosF, estatus: value.id });
      if (value.id == 100) {
        setDisabled(!disabled);
      }else{
        setDisabled(false);
      }
    } else {
      setValue("estatus", null);
    }
  };
  const handleChangeSolicitud = (event, value) => {
    if (value) {
      setValue("solicitud", value);
      setDato({ ...datosF, solicitud: value.idsolicitud });
    } else setValue("solicitud", null);
  };

  const onSubmit = (data) => {
    if (data && datosF.estatus != 0 && datosF.solicitud != 0) {
      serviciosSolicitudes.IndicadoresTareaByselect(
        (data) => {
          setCtl({
            ...ctl,
            indicadoresTarea: data.indicadoresTarea,
            infosol: data.infoSol,
            seguimientos: data.seguimientos,
            incidencias: data.incidencias,
            personas: data.personas,
            // indicadoresTareaP: data.indicadoresTareaP,
          });
        },
        setCargando,
        {
          ...datosF,
          idsolicitud: datosF.solicitud,
          estatus: datosF.estatus,
          finicio: data.prop_inicio,
          ffin: data.prop_fin,
        }
      );

      // console.log(datosF.estatus);
      // console.log(datosF.solicitud);
      // console.log("data", data.prop_inicio);
      // console.log("data", data.prop_fin);
    } else if (datosF.estatus == 0) {
    } else if (datosF.solicitud == 0) {
    }
  };

  // useEffect(() => {
  //   console.log("entra al useeffect");
  //   servicios.getSol(setData, setCargando);
  // }, []);

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <Paper>
              <Autocomplete
                options={getSol}
                getOptionLabel={(option) => option.titulo}
                getOptionSelected={(option, value) =>
                  option.idsolicitud == value.idsolicitud
                }
                onChange={handleChangeSolicitud}
                value={watch("solicitud")}
                renderInput={(params) => (
                  <TextField
                    label="SOLICITUD"
                    variant="outlined"
                    {...params}
                    error={Boolean(errors.solicitud)}
                    helperText={errors.solicitud}
                  />
                )}
              />
            </Paper>
          </Grid>
          <Grid item xs={2}>
            <Paper>
              <Autocomplete
                options={options}
                getOptionLabel={(option) => option.nestatus}
                getOptionSelected={(option, value) =>
                  option.nestatus == value.id
                }
                onChange={handleChangeEstatus}
                value={watch("estatus")}
                inputRef={register({
                  required: {
                    value: true,
                    message: "ESTATUS ES REQUERIDO",
                  },
                  minLength: {
                    value: 1,
                    message: "MÍNIMO 1 CARÁCTERES",
                  },
                })}
                renderInput={(params) => (
                  <TextField
                    label="ESTATUS"
                    variant="outlined"
                    {...params}
                    error={Boolean(errors.estatus)}
                    helperText={errors.estatus}
                  />
                )}
              />
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper>
              <TextField
                // InputProps={{ inputProps: { min: fechamin, max: fechamax } }}
                defaultValue={fechamin}
                id="outlined-error-helper-text"
                label="FECHA DE INICIO TAREA"
                variant="outlined"
                fullWidth
                name="prop_inicio"
                type="date"
                inputRef={register({
                  required: {
                    value: true,
                    message: "F. INICIO ES REQUERIDA",
                  },
                  minLength: {
                    value: 1,
                    message: "MÍNIMO 1 CARÁCTERES",
                  },
                })}
                disabled={disabled}
                error={Boolean(errors.fechamin)}
                helperText={errors.fechamin}
              />
            </Paper>
          </Grid>
          <Grid item xs={3}>
            <Paper>
              <TextField
                // InputProps={{ inputProps: { min: fechamin, max: fechamax } }}
                defaultValue={fechamin}
                id="outlined-error-helper-text"
                label="FECHA DE TÉRMINO TAREA"
                variant="outlined"
                fullWidth
                name="prop_fin"
                type="date"
                inputRef={register({
                  required: {
                    value: true,
                    message: "F. INICIO ES REQUERIDA",
                  },
                  minLength: {
                    value: 1,
                    message: "MÍNIMO 1 CARÁCTERES",
                  },
                })}
                disabled={disabled}
                error={Boolean(errors.fechamin)}
                helperText={errors.fechamin}
              />
            </Paper>
          </Grid>

          <Grid item xs={1}>
            <br />
            <FormControl>
              <Button type="submit">
                <Search />
              </Button>
            </FormControl>
          </Grid>
        </Grid>
      </form>
      <br />
    </div>
  );
};

export default HeaderSelectsGrafica;
